// extracted by mini-css-extract-plugin
export default {"emptyListHeader":"_2Pew78vJPxY1yLqQE55p1Q","emptyListImgBlock":"_1uyFIVgKSvg-agWjH56x73","emptyListMessage":"_36Sxcbj_N0wMcPN7Ebr86q"};